import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { faExclamationTriangle, faBuilding, faUser, faUserTie, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { RegionCascadeAnalysis } from '../../shared/regions-manager/regions-manager.component';

export interface CascadeConfirmationDialogData {
  title: string;
  cascadeAnalysis: RegionCascadeAnalysis;
}

@Component({
  selector: 'app-cascade-confirmation',
  templateUrl: './cascade-confirmation.component.html',
  styleUrls: ['./cascade-confirmation.component.scss']
})
export class CascadeConfirmationComponent implements OnInit {
  // Icons
  faExclamationTriangle = faExclamationTriangle;
  faBuilding = faBuilding;
  faUserTie = faUserTie;
  faUser = faUser;
  faCheckCircle = faCheckCircle;

  constructor(
    private dialogRef: MatDialogRef<CascadeConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CascadeConfirmationDialogData
  ) {}

  ngOnInit(): void {}

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  getConfirmButtonText(): string {
    const totalItems = this.data.cascadeAnalysis.totalItemsToDelete;
    if (totalItems === 0) {
      return 'Remove Region';
    } else {
      return `Remove Region & ${totalItems} Items`;
    }
  }

  hasCascadeItems(): boolean {
    return this.data.cascadeAnalysis.totalItemsToDelete > 0;
  }
}